import FastFieldSet from './FastFieldSet';

export default FastFieldSet;
